import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { smsKodRegExp } from 'enums/regExp';

export const smsKodValidation = () => [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || smsKodRegExp.test(value)) return Promise.resolve();
            if (value && !smsKodRegExp.test(value)) return Promise.reject(<TranslateText>SMS_INVALID</TranslateText>);
            return Promise.resolve();
        }
    })
];

export default smsKodValidation;
